<template>
    <div 
        :class="[
            'animate-pulse bg-pink/20 rounded',
            size === 'sm' ? 'h-4' : '',
            size === 'md' ? 'h-6' : '',
            size === 'lg' ? 'h-8' : '',
            size === 'xl' ? 'h-12' : '',
            width
        ]"
    >
    </div>
</template>

<script>
export default {
    name: 'LoadingSkeleton',
    props: {
        size: {
            type: String,
            default: 'md',
            validator: value => ['sm', 'md', 'lg', 'xl'].includes(value)
        },
        width: {
            type: String,
            default: 'w-full'
        }
    }
}
</script> 